import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import CreateModal from '../modals/CreateModal';
import UpdateModal from '../modals/UpdateModal';
import * as actions from '../../../action';
import * as c from '../../../constant';

function MachineryAppraisalContainer({
  getMachineryAppraisalList,
  machineryAppraisalList,
  applicationId,
  removeMachineryAppraisal,
  type,
  isLoading,
  permissions,
}) {
  const setModal = useContext(ModalContext);

  const handleAddMachineryAppraisal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal applicationId={applicationId} />,
      title: 'Add Appraisal',
      modalSize: 'modal-lg',
    });
  };

  const handleUpdateMachineryAppraisal = (id, data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateModal
          id={id}
          defaultValues={{
            ...data.attributes,
            machine_id: `${data.attributes.machine_id}`,
            actual_use_id: `${data.attributes.actual_use_id}`,
            date_acquired: `${moment(data.attributes.date_acquired).format(
              'MM/DD/YYYY'
            )}`,
          }}
          applicationId={data.id}
        />
      ),
      title: 'Update Appraisal',
      modalSize: 'modal-lg',
    });
  };

  const handleRemoveMachineryAppraisal = (id, data) => (e) => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure you want to remove this appraisal?',
      () => {
        removeMachineryAppraisal(id, data.id, () => {
          getMachineryAppraisalList(id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getMachineryAppraisalList(applicationId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getMachineryAppraisalList(applicationId);
  }, [applicationId]);

  return (
    <div className="card-content-listing">
      <div className="card p-0 mr-2">
        {isLoading ? (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <>
            <div className="row my-3 mx-2">
              {Acl(permissions, [
                'CREATE E2E RPT MACHINERY PROPERTY APPRAISALS',
              ]) && (
                <div className="col-12 d-flex justify-content-end">
                  <button
                    onClick={handleAddMachineryAppraisal}
                    type="button"
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary  mb-2"
                  >
                    Add Machinery Appraisal
                  </button>
                </div>
              )}
              <div className="table-div">
                <div className="row my-3 mx-2">
                  <table className="css-table table table-borderless table-sm table-striped table-hover">
                    <thead className="table-header">
                      <tr>
                        <td className="font-weight-bold">Kind of Machinery</td>
                        <td className="font-weight-bold">Brand and Model</td>
                        <td className="font-weight-bold">Capacity</td>
                        <td className="font-weight-bold">Date Acquired</td>
                        <td className="font-weight-bold">Condition</td>
                        <td className="font-weight-bold">
                          Estimated Economic Life
                        </td>
                        <td className="font-weight-bold">Year Installed</td>
                        <td className="font-weight-bold">
                          Year of Initial Operation
                        </td>
                        <td className="font-weight-bold">Original Cost</td>
                        <td className="font-weight-bold">Conversion Factor</td>
                        <td className="font-weight-bold">RCN</td>
                        <td className="font-weight-bold">No. of Years Used</td>
                        <td className="font-weight-bold">
                          Total Depreciation %
                        </td>
                        <td className="font-weight-bold">
                          Total Depreciation Value
                        </td>
                        <td className="font-weight-bold"> Depreciated Value</td>
                        <td className="font-weight-bold text-center">
                          Actions
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {machineryAppraisalList &&
                        machineryAppraisalList.length <= 0 && (
                          <tr className="text-center">
                            <td className="history-color" colSpan="9">
                              No data
                            </td>
                          </tr>
                        )}
                      {machineryAppraisalList &&
                        machineryAppraisalList.map((item) => (
                          <tr key={item.id}>
                            <td className="history-color">
                              {_.get(
                                item,
                                'included.machineryMachine.attributes.name'
                              ) || '--'}
                            </td>
                            <td className="history-color">
                              {_.get(item, 'attributes.brand_and_model') ||
                                '--'}
                            </td>
                            <td className="history-color">
                              {_.get(item, 'attributes.capacity') || '--'}
                            </td>
                            <td className="history-color">
                              {_.get(item, 'attributes.date_acquired') || '--'}
                            </td>
                            <td className="history-color">
                              {_.get(item, 'attributes.condition') || '--'}
                            </td>
                            <td className="history-color">
                              {_.get(
                                item,
                                'attributes.economic_life_estimated'
                              ) || '--'}
                            </td>
                            <td className="history-color">
                              {_.get(item, 'attributes.year_installed') || '--'}
                            </td>
                            <td className="history-color">
                              {_.get(
                                item,
                                'attributes.year_of_initial_operation'
                              ) || '--'}
                            </td>
                            <td className="history-color">
                              {_.get(item, 'attributes.original_cost') || '--'}
                            </td>
                            <td className="history-color">
                              {_.get(item, 'attributes.conversion_factor') ||
                                '--'}
                            </td>
                            <td className="history-color">
                              {_.get(item, 'attributes.rcn') || '--'}
                            </td>
                            <td className="history-color">
                              {_.get(item, 'attributes.no_of_year_used') || 0}
                            </td>
                            <td className="history-color">
                              {_.get(
                                item,
                                'attributes.total_depreciation_percent'
                              ) || '--'}
                            </td>
                            <td className="history-color">
                              {_.get(
                                item,
                                'attributes.total_depreciation_value'
                              ) || '--'}
                            </td>
                            <td className="history-color">
                              {_.get(item, 'attributes.depreciation_value') ||
                                '--'}
                            </td>
                            {type !== 'history' ? (
                              <td className="text-center">
                                <div className="d-flex">
                                  {Acl(permissions, [
                                    'UPDATE E2E RPT MACHINERY PROPERTY APPRAISALS',
                                  ]) && (
                                    <button
                                      onClick={handleUpdateMachineryAppraisal(
                                        applicationId,
                                        item
                                      )}
                                      type="button"
                                      className="btn-blank"
                                    >
                                      <i className="far fa-edit icon-edit" />
                                    </button>
                                  )}
                                  {Acl(permissions, [
                                    'DELETE E2E RPT MACHINERY PROPERTY APPRAISALS',
                                  ]) && (
                                    <button
                                      type="button"
                                      className="btn-blank"
                                      onClick={handleRemoveMachineryAppraisal(
                                        applicationId,
                                        item
                                      )}
                                    >
                                      <i className="far fa-trash-alt icon-delete" />
                                    </button>
                                  )}
                                </div>
                              </td>
                            ) : (
                              <>
                                <td />
                              </>
                            )}
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

MachineryAppraisalContainer.defaultProps = {
  type: '',
  applicationId: '',
};

MachineryAppraisalContainer.propTypes = {
  getMachineryAppraisalList: PropTypes.instanceOf(Function).isRequired,
  machineryAppraisalList: PropTypes.instanceOf(Array).isRequired,
  applicationId: PropTypes.string,
  removeMachineryAppraisal: PropTypes.instanceOf(Function).isRequired,
  type: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  permissions: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  machineryAppraisalList: _.get(api, `${c.GET_MACHINERY_APPRAISAL}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_MACHINERY_APPRAISAL) > -1,
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(MachineryAppraisalContainer);
